import * as React from 'react'

import { cn } from '~/styled'

import { useCarousel } from './Carousel'

export type TCarouselSlideGap = 'none' | 0 | 1 | 2 | 3 | 4

// Horizontal padding applied around each slide's content, on the same
// spacing scale as Flex/ToggleGroup's gap. 'none' renders full-bleed slides.
export const toSlideGapClass: Record<TCarouselSlideGap, string> = {
  none: '',
  0: 'px-0.5',
  1: 'px-1',
  2: 'px-2',
  3: 'px-3',
  4: 'px-4'
}

// Slides read the gap via context so it is configured once on the slider.
export const CarouselSlideGapContext = React.createContext<TCarouselSlideGap>(3)

type CarouselSliderProps = {
  children?: React.ReactNode
  className?: string
  gap?: TCarouselSlideGap
  overflow?: boolean
  tabIndex?: number
}

export const CarouselSlider = ({
  children,
  className,
  gap = 3,
  overflow,
  tabIndex = 0,
  ...rest
}: CarouselSliderProps) => {
  const { emblaRef } = useCarousel()

  return (
    <div
      ref={emblaRef}
      className={cn(
        'ml-[50%]',
        '-translate-x-1/2',
        'cursor-grab',
        overflow ? 'overflow-visible' : 'overflow-hidden',
        className
      )}
      role="listbox"
      aria-live="polite"
      tabIndex={tabIndex}
      {...rest}
    >
      <div className="flex">
        <CarouselSlideGapContext.Provider value={gap}>
          {children}
        </CarouselSlideGapContext.Provider>
      </div>
    </div>
  )
}
